import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Injector,
    Input,
    OnDestroy,
    Output,
    QueryList,
    ViewChild
} from '@angular/core';
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {ContractControlAdvanceFilterParamType} from "../../../../pages/contract-control/advanced-filters";
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from "../../applied-filters-updater";
import {IFilterChooser, IFilterChooserToken} from "../../filter-chooser";
import {
    AdvancedFilterFieldTypesEnum,
    AdvanceFilterParamType,
    IAdvancedFilterListItem,
    IAdvanceFilter
} from "../advance-filter";
import {DatepickerFilterComponent} from "../filter-implementaitons/datepicker-filter/datepicker-filter.component";

@Component({
    selector: 'app-applied-advanced-filter',
    templateUrl: './applied-advanced-filter.component.html',
    styleUrl: './applied-advanced-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppliedAdvancedFilterComponent<T> implements OnDestroy {
    private openFilterTimeout;

    protected readonly DatepickerFilterComponent = DatepickerFilterComponent;
    protected readonly AdvancedFilterFieldTypesEnum = AdvancedFilterFieldTypesEnum;

    @Input() items: IAdvancedFilterListItem<T>[]
    @Input() loading: boolean;
    @Input() filtersList: IAdvanceFilter<ContractControlAdvanceFilterParamType>[] = [];
    @Output() removeFilter: EventEmitter<IAdvanceFilter<ContractControlAdvanceFilterParamType>> = new EventEmitter<IAdvanceFilter<ContractControlAdvanceFilterParamType>>();
    @Output() filterChanged: EventEmitter<IAdvanceFilter<ContractControlAdvanceFilterParamType>> = new EventEmitter<IAdvanceFilter<ContractControlAdvanceFilterParamType>>();
    @Output() addNewFilter: EventEmitter<IAdvanceFilter<AdvanceFilterParamType>> = new EventEmitter<IAdvanceFilter<AdvanceFilterParamType>>();
    @Output() search: EventEmitter<string> = new EventEmitter();
    @ViewChild('p1') filterPopovers: QueryList<NgbPopover>;


    constructor(public injector: Injector,
                @Inject(IFilterChooserToken) public filterChooser: IFilterChooser<ContractControlAdvanceFilterParamType>,
                @Inject(IAppliedFiltersUpdaterToken) private filterUpdater: IAppliedFiltersUpdater<ContractControlAdvanceFilterParamType>) {
    }

    ngOnDestroy(): void {
        if (this.openFilterTimeout) {
            clearTimeout(this.openFilterTimeout);
        }
    }

    onRemoveFilterClick(filter: IAdvanceFilter<ContractControlAdvanceFilterParamType>) {
        this.removeFilter.next(filter);
    }

    isDisable(p1: NgbPopover, filter: IAdvanceFilter<ContractControlAdvanceFilterParamType>) {
        if (p1.isOpen() === false && filter.isOpened) {
            p1.open();
        }
        return false;
    }

    onPopoverClose(p1: NgbPopover, filter: IAdvanceFilter<ContractControlAdvanceFilterParamType>) {
        this.filterUpdater.filterClose({
            uuid: filter.uuid,
        })

        p1.close();
    }

    addNewFilterGroupClicked(filter: IAdvanceFilter<AdvanceFilterParamType>) {
        this.addNewFilter.emit(filter);
    }


    advancedFilterSearch(search: string) {
        this.search.emit(search);
    }
}
